export default __webpack_public_path__ + "static/4-gridgarden-87d851e70bea5472917327e72b5f0a28.jpeg";